import axios, { AxiosError } from "axios";
import { FileUrl } from "../../../common/components/molecule/FileListManager/FileListManager";
import { FileDtoIn } from "../../../common/types/files.types";
import { convertFileToFileDto } from "../../../common/utils/fileReader";
import { APIGenerator } from "../../../utils/genericAPI/GenerateAPI";
import { BConnector, BConnectorPatch, MeasurandData, Station, StationPatch } from "../types/stations.types";
import { FilterPoint, Point } from "../../../common/analysis/filter/types/types";
import { PayGoCreditDecrypted } from "../../paygo/types/paygo.types";
import { CallbackFunction } from "../../../common/types/callback.types";

export const  BASE_URL_STATION = process.env.REACT_APP_BACKEND_API_URL + "/api/v1/stations";
export const  BASE_URL_STATION_CLIENT = process.env.REACT_APP_BACKEND_API_URL + "/api/v1/clients/stations"
export const BASE_URL_CONNECTOR  = process.env.REACT_APP_BACKEND_API_URL + "/api/v1/connectors"
export const stationAPI = new APIGenerator<Station, StationPatch, StationPatch>(BASE_URL_STATION);
export const connectorAPI = new APIGenerator<BConnector, BConnectorPatch, BConnectorPatch>(BASE_URL_CONNECTOR);
export const getStationThumbnailSrc = (stationId : string) => {
  return `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/stations/${stationId}/thumbnail`;
}

export const addThumbnailStationAxios = async (stationId: string, fileURL: FileUrl) => {
    const fileList : FileDtoIn[]  | undefined =fileURL ? await convertFileToFileDto([fileURL]) : undefined
        const file = fileList?.[0] || null;
    if (file && !file.ignore) {
        return axios.post<Station>(getStationThumbnailSrc(stationId), file)
    }
    if (!file) {
        return Promise.reject(new Error("File is not valid") as any);
    }
}

export const getEnergyActiveImportData = async (stationId: string, filter?: FilterPoint) => {
    const startDate = filter?.startDate || "2025-06-01T00:00:00Z"
    const stopDate = filter?.stopDate || "2025-07-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate

    const aggregateWindow = filter?.aggregateWindow || "1d"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow

        return  (await axios.get<Point[]>(`${BASE_URL_STATION}/${stationId}/analysis/Energy.Active.Import.Register?${params}`, { params: filter })).data

}

export const getDecryptedPaygoCreditOfStation = async (stationId: string, paygoCode: string, callback?: CallbackFunction<PayGoCreditDecrypted, AxiosError>) => {
    return (await axios.post<PayGoCreditDecrypted>(`${BASE_URL_STATION}/${stationId}/paygo_decrypt`, {token: paygoCode})).data;
}

export const getConnectorEnergyConsumptionData = async (connectorId: string, filter?: FilterPoint) => {
    const startDate = filter?.startDate || "2025-06-01T00:00:00Z"
    const stopDate = filter?.stopDate || "2025-07-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate
    const aggregateWindow = filter?.aggregateWindow || "1d"
    const params = "range="+range+"&aggregateWindow="+aggregateWindow
    return (await axios.get<Point[]>(`${BASE_URL_CONNECTOR}/${connectorId}/analysis/Energy.Active.Import.Register?${params}`)).data;
}

export const getConnectorData = async (connectorId: string, measurand: MeasurandData,  filter?: FilterPoint) => {
    const startDate = filter?.startDate || "2025-06-01T00:00:00Z"
    const stopDate = filter?.stopDate || "2025-07-01T00:00:00Z"
    let difference = "false"
   const range= "start="+startDate+",stop="+ stopDate
    if (measurand === "Energy.Active.Import.Register") {
        difference = "true"
    }

    const aggregateWindow = filter?.aggregateWindow || "1d"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow+ "&difference="+difference


    return (await axios.get<Point[]>(`${BASE_URL_CONNECTOR}/${connectorId}/analysis/${measurand}?${params}`)).data;
}

export const getSationData= async (stationId: string, measurand: MeasurandData,  filter?: FilterPoint) => {
    const startDate = filter?.startDate || "2025-06-01T00:00:00Z"
    const stopDate = filter?.stopDate || "2025-07-01T00:00:00Z"
    const range= "start="+startDate+",stop="+ stopDate

    let difference = "false"

    if (measurand === "Energy.Active.Import.Register") {
        difference = "true"
    }

    const aggregateWindow = filter?.aggregateWindow || "1d"

    const params = "range="+range+"&aggregateWindow="+aggregateWindow+ "&difference="+difference

        return  (await axios.get<Point[]>(`${BASE_URL_STATION}/${stationId}/analysis/${measurand}?${params}`, { params: filter })).data

}

export const ConnectorAnalysisAPI = {
    getConnectorEnergyConsumptionData
}


export default stationAPI;